<div class="agpr-curatedAdditionalSettings">
    @if (hasPrecisionClipPermission) {
        <div>
            <span class="agpr-curatedAdditionalSettings-label"> {{ 'Monitor.precisionClipping' | localize }} </span>
            <div class="agpr-curatedAdditionalSettings-indentWrapper">
                <agpr-button
                    [id]="id + '_curated_open_precision_clip_dialog'"
                    [disabled]="briefingDirty"
                    [tooltip]="briefingDirty ? 'Briefings.blockType.precisionClip.mustSave.message' : ''"
                    [style]="buttonTypes.tertiary"
                    label="Briefings.blockType.precisionClip.generate"
                    (click)="openPrecisionClipDialog()"
                ></agpr-button>
            </div>
        </div>
    }

    <div>
        <span class="agpr-curatedAdditionalSettings-label"> {{ 'Mention.customization.insights' | localize }} </span>
        <agpr-checkbox
            [id]="id + '_curated_showInsights'"
            label="Mention.customization.showInsights"
            infoCircleTooltip="Briefings.blockType.autoGeninsights.showInsights.tooltip"
            [binary]="true"
            [(ngModel)]="showInsights"
            (ngModelChange)="showInsightChange()"
        ></agpr-checkbox>

        @if (showInsights) {
            <div class="agpr-curatedAdditionalSettings-indentWrapper">
                <agpr-button
                    [id]="id + '_curated_open_insights_dialog_button'"
                    [disabled]="briefingDirty"
                    [tooltip]="briefingDirty ? 'Briefings.blockType.autoGeninsights.mustSave.message' : ''"
                    [style]="buttonTypes.tertiary"
                    label="Briefings.blockType.autoGeninsights.label"
                    (click)="openAutoGenerateDialog()"
                ></agpr-button>
            </div>
        }
    </div>
</div>
